"use client";
import { flushEventQueue } from "@/utils/posthog";
import posthog from "posthog-js";
import { isConsentCategoryOn } from "privacy-consent";
import { useEffect } from "react";
import { object, picklist, safeParse } from "valibot";

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    cact?: any;
  }
}

const ResultSchema = object({
  consent: object({
    status: picklist(["all-on", "all-off", "mixed", "unset"]),
    categories: object({
      "2": object({
        status: picklist(["on", "off", "unset"]),
      }),
    }),
  }),
});

const clearPostHogLocalState = () => {
  try {
    if (typeof localStorage === "undefined") return;

    for (const key of Object.keys(localStorage)) {
      if (key.startsWith("__ph_opt_in_out")) {
        localStorage.removeItem(key);
      }
    }
  } catch (error) {
    return;
  }
};

export function PostHogConsent() {
  useEffect(() => {
    const handleConsentChange = (result: unknown) => {
      const vResult = safeParse(ResultSchema, result);
      if (!vResult.success) return;

      if (isConsentCategoryOn(vResult.output, "2")) {
        if (!posthog.__loaded) {
          posthog.init("phc_WeKSNJk1hLH5nyHzcml16pikZvhEHysBnH99iGTVjme", {
            api_host: "/itmcom",
            ui_host: "https://eu.posthog.com",
            persistence: "memory",
            disable_session_recording: true,
            defaults: "2025-05-24",
            session_recording: {
              maskTextSelector: ".sensitive",
              maskAllInputs: true,
              maskInputFn: (text, element) => {
                if (element?.id && ["firstname", "lastname"].includes(element?.id)) {
                  return text;
                }

                return "*".repeat(text.length);
              },
            },
          });
        }

        posthog.opt_in_capturing();

        flushEventQueue();
      } else {
        if (posthog.__loaded) {
          posthog.opt_out_capturing();
        }
        clearPostHogLocalState();
      }
    };

    window?.cact?.("consent.get", handleConsentChange);
    window?.cact?.("consent.onUpdate", handleConsentChange);
  }, []);

  return null;
}
